import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IMotivAddPayload, IMotivUpdatePayload } from './motive-proiecte.interface';

@Injectable({
    providedIn: 'root'
})
export class MotiveProiecteService {
    // private token!: string;
    // private httpOptions: any;

    private basePath = environment.interop.basePath;
    private listMotiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteMotiv.list;
    private listDTMotiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteMotiv.listDT;
    private addMotivURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteMotiv.store;
    private updateMotivURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteMotiv.update;
    private deleteMotivURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteMotiv.delete;
    private changeStatusActiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteMotiv.changeActive;
    private listStatusActiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteMotiv.listActive;

    constructor(private http: HttpClient) { }

    listMotive() {
        return this.http.get(this.listMotiveURL);
    }

    listDTMotive() {
        return this.http.post(this.listDTMotiveURL, {});
    }

    addMotiv(data: IMotivAddPayload) {
        return this.http.post(this.addMotivURL, data);
    }

    updateMotiv(data: IMotivUpdatePayload) {
        return this.http.put(this.updateMotivURL, data);
    }

    deleteMotiv(id: number) {
        return this.http.delete(this.deleteMotivURL + id);
    }

    listStatusActive() {
        return this.http.get(this.listStatusActiveURL);
    }

    changeStatusActive(id: number) {
        return this.http.get(this.changeStatusActiveURL + id);
    }

    // setToken(token: string) {
    //     this.token = token;
    //     this.httpOptions = {
    //         headers: new HttpHeaders({
    //             'Content-Type': 'application/json',
    //             Accept: 'application/json',
    //             Authorization: `Bearer ${this.token}`,
    //         }),
    //     };
    // }
}
